<template>
  <div>
    <div class="con">
      <div class="header">
        <h3>统一登录管理平台</h3>
        <div class="tips">
          <div>
            <!-- <el-badge :value="news" class="item">
              <el-button size="mini" style="background:#36a;color:#fff;border:0">通知</el-button>
            </el-badge>
            <el-button size="mini" style="marginLeft:1.5rem;background:#36a;color:#fff;border:0">帮助</el-button> -->
            <div class="personal">
              <span class="name">
                {{ name }}
                <i
                  :style="{ transform: show == 1 ? 'rotate(180deg)' : '' }"
                ></i>
              </span>
              <div class="cascader" @click="rotate">
                <el-cascader
                  style="opacity: 0"
                  v-model="value"
                  :options="options"
                  :props="{ expandTrigger: 'hover' }"
                  @change="handleChange"
                ></el-cascader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.name = sessionStorage.getItem("admin");
  },
  data() {
    return {
      name: "",
      show: 0,
      news: 12,
      value: [],
      options: [
        {
          value: "注销",
          label: "注销",
        },
      ],
    };
  },
  methods: {
    handleChange(value) {
      console.log(value);
      if (value == "注销") {
        this.$router.replace("/login");
        this.$message({
          message: "成功退出",
          type: "success",
        });
        sessionStorage.clear();
      }
      this.show = this.show == 1 ? 0 : 1;
      this.show = 0;
    },
    rotate() {
      this.show = this.show == 1 ? 0 : 1;
    },
  },
};
</script>

<style scoped>
.con {
  height: 5rem;
  background: #36a;
}
.header {
  height: 5rem;
  padding: 0 1rem;
  margin: 0 auto;
  display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
  display: -ms-flexbox; /* Firefox 18+ */
  display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
  display: -moz-box; /* Firefox 17- */
  /* -webkit-box-pack: justify; */
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.header > h3 {
  color: #fff;
  font-size: 1.5rem;
}
.personal {
  display: inline-block;
  position: relative;
  margin-left: 5rem;
}
.personal > .name {
  color: #fff;
  font-size: 0.8rem;
}
.personal > .name > i {
  transform: 0.5s;
  display: inline-block;
  margin-left: 0.1rem;
  vertical-align: middle;
  width: 0.6rem;
  height: 0.3rem;
  background: url("../assets/img/icon_arrow3-2.png");
}
.personal > .cascader {
  width: 2rem;
  height: 3rem;
  position: absolute;
  left: 0;
  top: -0.5rem;
}
.tips {
  margin-right: 5rem;
}
</style>